<div class="min-h-screen bg-gray-50 p-4 md:p-6">
  <div class="max-w-7xl mx-auto space-y-6">
    <!-- Header Section -->
    <div
      class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
    >
      <div class="space-y-1">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900">
          Gerenciamento de Categorias
        </h1>
        <p class="text-gray-600">Organize seus produtos por categorias</p>
      </div>

      <!-- Header Actions -->
      <div class="flex gap-3">
        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          (click)="addCategory()"
          aria-label="Criar nova categoria"
        >
          <app-icon name="add" size="sm" class="mr-2"></app-icon>
          Nova Categoria
        </button>
      </div>
    </div>

    <!-- Stats Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <!-- Total Categories Card -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center"
            >
              <app-icon name="category" color="primary"></app-icon>
            </div>
          </div>
          <div class="ml-4 flex-1">
            <div class="text-sm font-medium text-gray-500">
              Total de Categorias
            </div>
            <div class="text-2xl font-bold text-gray-900">
              {{ totalCategories() }}
            </div>
            <div class="text-xs text-gray-500 mt-1">Todas as categorias</div>
          </div>
        </div>
      </div>

      <!-- Active Categories Card -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 bg-secondary-100 rounded-lg flex items-center justify-center"
            >
              <app-icon name="check_circle" color="success"></app-icon>
            </div>
          </div>
          <div class="ml-4 flex-1">
            <div class="text-sm font-medium text-gray-500">
              Categorias Ativas
            </div>
            <div class="text-2xl font-bold text-gray-900">
              {{ activeCategories() }}
            </div>
            <div class="text-xs text-gray-500 mt-1">Em uso no catálogo</div>
          </div>
        </div>
      </div>

      <!-- Inactive Categories Card -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center"
            >
              <app-icon name="cancel" color="error"></app-icon>
            </div>
          </div>
          <div class="ml-4 flex-1">
            <div class="text-sm font-medium text-gray-500">
              Categorias Inativas
            </div>
            <div class="text-2xl font-bold text-gray-900">
              {{ inactiveCategories() }}
            </div>
            <div class="text-xs text-gray-500 mt-1">Desabilitadas</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="bg-white rounded-lg shadow p-6">
      <form
        [formGroup]="filterForm"
        class="space-y-4 md:space-y-0 md:flex md:items-end md:gap-4"
      >
        <!-- Search Input -->
        <div class="flex-1">
          <label
            for="search"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Buscar categorias
          </label>
          <div class="relative">
            <input
              id="search"
              type="text"
              formControlName="search"
              placeholder="Nome ou descrição..."
              class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            />
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            >
              <app-icon name="search" size="sm" color="gray"></app-icon>
            </div>
          </div>
        </div>

        <!-- Results Info -->
        <div class="md:w-auto">
          <div class="text-sm text-gray-600 whitespace-nowrap">
            {{ resultCount() }} categoria(s) encontrada(s)
          </div>
        </div>
      </form>
    </div>

    <!-- Loading State -->
    @if (isLoading()) {
    <div class="bg-white rounded-lg shadow p-12">
      <div class="flex items-center justify-center">
        <div class="text-center space-y-3">
          <div
            class="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto"
          ></div>
          <p class="text-gray-600">Carregando categorias...</p>
        </div>
      </div>
    </div>
    }

    <!-- Empty State -->
    @if (showEmptyState()) {
    <div class="bg-white rounded-lg shadow p-12">
      <div class="text-center space-y-4">
        <app-icon name="category" size="lg" color="gray"></app-icon>
        <div>
          <h3 class="text-lg font-medium text-gray-900">
            Nenhuma categoria encontrada
          </h3>
          <p class="text-gray-500 mt-1">
            Tente ajustar os filtros ou crie uma nova categoria
          </p>
        </div>
        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          (click)="addCategory()"
        >
          <app-icon name="add" size="sm" class="mr-2"></app-icon>
          Nova Categoria
        </button>
      </div>
    </div>
    }

    <!-- Categories Grid -->
    @if (!isLoading() && filteredCategories().length > 0) {
    <div class="bg-white rounded-lg shadow">
      <!-- Mobile View (Cards) -->
      <div class="block lg:hidden">
        <div class="p-4 space-y-4">
          @for (category of filteredCategories(); track category.id) {
          <div class="border border-gray-200 rounded-lg p-4 space-y-3">
            <div class="flex items-start justify-between">
              <div class="flex-1">
                <div class="flex items-center gap-2 mb-2">
                  <h3 class="font-medium text-gray-900">{{ category.name }}</h3>
                  <span
                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                    [class]="getStatusClass(category.active)"
                  >
                    {{ getStatusText(category.active) }}
                  </span>
                </div>
                <p class="text-sm text-gray-500 mb-2">
                  {{ category.description }}
                </p>
                <div class="text-sm text-gray-500">
                  {{ category.productCount }} produto(s)
                </div>
              </div>
            </div>

            <div
              class="flex items-center justify-between pt-3 border-t border-gray-100"
            >
              <div class="text-xs text-gray-400">
                Criada em {{ formatDate(category.createdAt) }}
              </div>
              <div class="flex space-x-2">
                <button
                  class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                  (click)="toggleStatus(category)"
                  [attr.aria-label]="
                    category.active ? 'Desativar categoria' : 'Ativar categoria'
                  "
                >
                  <app-icon
                    [name]="category.active ? 'toggle_on' : 'toggle_off'"
                    size="sm"
                  >
                  </app-icon>
                </button>
                <button
                  class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                  (click)="editCategory(category)"
                  aria-label="Editar categoria"
                >
                  <app-icon name="edit" size="sm"></app-icon>
                </button>
                <button
                  class="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  (click)="deleteCategory(category)"
                  aria-label="Excluir categoria"
                >
                  <app-icon name="delete" size="sm"></app-icon>
                </button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Desktop View (Table) -->
      <div class="hidden lg:block">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Nome
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Descrição
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Produtos
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Data de Criação
                </th>
                <th
                  class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              @for (category of filteredCategories(); track category.id) {
              <tr class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-gray-900">
                    {{ category.name }}
                  </div>
                </td>
                <td class="px-6 py-4">
                  <div class="text-sm text-gray-500 max-w-xs truncate">
                    {{ category.description }}
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ category.productCount }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    [class]="getStatusClass(category.active)"
                  >
                    {{ getStatusText(category.active) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ formatDate(category.createdAt) }}
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                >
                  <div class="flex justify-end space-x-2">
                    <button
                      class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                      (click)="toggleStatus(category)"
                      [attr.aria-label]="
                        category.active
                          ? 'Desativar categoria'
                          : 'Ativar categoria'
                      "
                    >
                      <app-icon
                        [name]="category.active ? 'toggle_on' : 'toggle_off'"
                        size="sm"
                      >
                      </app-icon>
                    </button>
                    <button
                      class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                      (click)="editCategory(category)"
                      aria-label="Editar categoria"
                    >
                      <app-icon name="edit" size="sm"></app-icon>
                    </button>
                    <button
                      class="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                      (click)="deleteCategory(category)"
                      aria-label="Excluir categoria"
                    >
                      <app-icon name="delete" size="sm"></app-icon>
                    </button>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
  </div>
</div>
